import { FC } from 'react';
import { SessionContainerProps } from '../config';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/useStores';

export interface ExerciseData extends Record<string, unknown> {
  exercise?: any;
  inPath?: boolean;
  sessionStepId?: string;
  pathId?: string | null;
  userId?: string;
  language?: string | null;
  setDecided: (decided: boolean) => void;
  setExerciseId: (exerciseId: string) => void;
  fetchMyExerciseById: (exerciseId: string) => void;
  addToDashboard: (createMyExerciseId: string) => void;
}

const _ContainExercise: FC<SessionContainerProps<ExerciseData>> = ({
  onNext,
  onFinish,
  children,
}) => {
  const rootStore = useStores();
  const userId = rootStore.user?.user?._id;
  const contentId = rootStore.treeNav.content.sessionStep?.contentId;
  const pathId = rootStore.treeNav.content.session?.path;
  const sessionStepId = rootStore.treeNav.content.sessionStep?.ownId;
  const exercise = contentId
    ? rootStore.exercise.getExercise(contentId)
    : undefined;
  const path = pathId ? rootStore.path.getPath(pathId) : undefined;
  const inPath = !!pathId;
  const labels = rootStore?.language.translate.MOBILE?.SESSION;

  const setDecided = (decided: boolean) =>
    rootStore.treeNav.choices.updateExercise({ decided });
  const setExerciseId = (exerciseId: string) =>
    rootStore.treeNav.choices.updateExercise({ exerciseId });

  const fetchMyExerciseById = (exerciseId: string) =>
    rootStore.exercise.fetchMyExerciseById(exerciseId);

  const addToDashboard = (createMyExerciseId: string) =>
    rootStore.exercise.addToDashboard(
      exercise?._id,
      createMyExerciseId,
      path?.image || ''
    );

  return children({
    onNext,
    onFinish,
    data: {
      exercise,
      inPath,
      sessionStepId,
      pathId,
      userId,
      language: path?.language,
      setDecided,
      setExerciseId,
      addToDashboard,
      fetchMyExerciseById,
    },
    labels,
  });
};

export const ContainExercise = observer(_ContainExercise);
